/* eslint-disable @typescript-eslint/no-unused-vars */

import { useContext, useRef, useState } from 'react';
import { Box, Flex, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import styles from './styles.module.scss';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { requestReload } from '@/state/common';
import IssueForm from '@/modules/AlphaPWA/PlayerShares/issueForm/form';
import { getPresaleSignature, getPresaleSignatureV2 } from '@/services/presale';
import { WalletContext } from '@/contexts/wallet-context';
import useTradeKey from '@/hooks/playerShareToken/useTradeKey';
import { ROUTE_PATH } from '@/constants/route-path';
import { useRouter } from 'next/router';
import { closeModal } from '@/state/modal';
import { ISSUE_KEY_MODAL } from '@/modules/AlphaPWA/PlayerShares';
import { showError } from '../../Profiles/TradeKey/components/toast';
import { getErrorMessageContract, getUrlToSwap } from '@/utils/helpers';

const IssueFormContainer = () => {
  const refForm = useRef<any>();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { addressL2 } = useContext(WalletContext);
  const { issueKeyByTwitter, scanTrxAlpha } = useTradeKey();
  const router = useRouter();

  const onSubmit = async (values: any) => {
    const { username, twitterProfile, numberOfKeys, amountTC } = values;
    try {
      setSubmitting(true);
      if (!addressL2) {
        return;
      }
      const { signature }: any = (await getPresaleSignatureV2({
        address: addressL2,
        twitter_name: username,
      })) as unknown as string;

      const tx = await issueKeyByTwitter({
        twitter_id: twitterProfile.twitter_id,
        name: twitterProfile.twitter_name,
        symbol: twitterProfile.twitter_username,
        signature: signature,
        token_amount: numberOfKeys,
        tc_amount: amountTC,
      });
      console.log(tx);

      // showSuccess({
      //   message: `Create key success!`,
      //   url: getExplorer(tx.hash, 'nos', 'tx'),
      // });
      await scanTrxAlpha(tx.hash || tx.transactionHash);
      dispatch(closeModal({ ISSUE_KEY_MODAL }));

      if (Number(numberOfKeys) > 0) {
        router.push(
          `${ROUTE_PATH.ALPHA_MOBILE_PROFILE}/${twitterProfile.twitter_id}`
        );
      } else {
        // router.push(
        //   `${ROUTE_PATH.ALPHA_TRADE}?address=${twitterProfile.twitter_id}`
        // );

        router.push(getUrlToSwap(twitterProfile?.twitter_id));
      }

      dispatch(requestReload());
    } catch (e) {
      showError({
        ...getErrorMessageContract(e),
      });
      console.log('IssueFormContainer', e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Flex
      className={styles.formContainer}
      direction={'column'}
      alignItems={'center'}
      gap={3}
    >
      <Text className={styles.formTitle}>Issue placeholder keys</Text>
      <Box className={styles.formWrapper} mt={7}>
        <Form
          onSubmit={onSubmit}
          initialValues={{
            numberOfKeys: 1,
          }}
        >
          {({ handleSubmit }: any) => (
            <IssueForm
              handleSubmit={handleSubmit}
              ref={refForm}
              submitting={submitting}
            />
          )}
        </Form>
      </Box>
      <Text className={styles.formDesc} mt={4}>
        Issue placeholder keys for your favorite influencers, be the first to
        get their keys, and earn 20% by inviting them to New Bitcoin City.
      </Text>
      <Box
        className={styles.formWrapper_border}
        w={'100%'}
        px={8}
        py={6}
        bg={'#F4F4F4'}
        borderRadius={'8px'}
      >
        <Text color={'#1C1C1C'} fontSize={'12px'} fontWeight={600}>
          How it works?
        </Text>
        <UnorderedList fontSize={'12px'} fontWeight={400} color={'#5B5B5B'}>
          <ListItem className={styles.formDesc}>
            Enter their Twitter username
          </ListItem>
          <ListItem className={styles.formDesc}>
            A new Alpha will be created, linked to their Twitter account, with
            placeholder keys issued immediately.
          </ListItem>
          <ListItem className={styles.formDesc}>
            Be the first to purchase their keys.
          </ListItem>
          <ListItem className={styles.formDesc}>
            Issuing placeholder keys incurs a small TC fee.
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  );
};

export default IssueFormContainer;
